export default __webpack_public_path__ + "static/media/win-vista-logo.15cb6141.png";